import { render, staticRenderFns } from "./ModalDiagnosticoSociambientalEmLote.vue?vue&type=template&id=70a5b624&lang=pug"
import script from "./ModalDiagnosticoSociambientalEmLote.vue?vue&type=script&lang=js"
export * from "./ModalDiagnosticoSociambientalEmLote.vue?vue&type=script&lang=js"
import style0 from "./ModalDiagnosticoSociambientalEmLote.vue?vue&type=style&index=0&id=70a5b624&prod&lang=scss&slot-scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports